import { IOHelper, utils } from '@neo-one/client-common';
import { ContractParameterBase } from './ContractParameterBase';
import { ContractParameterType } from './ContractParameterType';
export class ArrayContractParameter extends ContractParameterBase {
    constructor(value) {
        super();
        this.type = ContractParameterType.Array;
        this.value = value;
        this.sizeInternal = utils.lazy(() => IOHelper.sizeOfArray(this.value, (val) => val.size));
    }
    get size() {
        return this.sizeInternal();
    }
    asBoolean() {
        return this.value.length > 0;
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        writer.writeArray(this.value, (parameter) => parameter.serializeWireBase(writer));
    }
    serializeJSON(context) {
        return {
            type: 'Array',
            value: this.value.map((val) => val.serializeJSON(context)),
        };
    }
}

//# sourceMappingURL=ArrayContractParameter.js.map
